import { OpportunityReviewViewState } from '@models/SavedViews';
import CreateCopyViewButton from '../copy-view/CreateCopyViewButton';
import React from 'react';
import { SavedViewButtonsTrackingTags } from '@ecosystem/newron-client-lib/build/saved-views/types';

export interface Props {
  opportunityReviewViewState: OpportunityReviewViewState;
  copyViewTracking: Object;
}

const OpportunityReviewCopyViewButton: React.FC<Props> = ({ opportunityReviewViewState, copyViewTracking }) => {
  const createViewState = () => {
    return opportunityReviewViewState;
  };
  const createTrackingTags = () => {
    return copyViewTracking as SavedViewButtonsTrackingTags;
  };

  return <CreateCopyViewButton createViewFunction={createViewState} copyViewTracking={createTrackingTags} />;
};

export default OpportunityReviewCopyViewButton;
